// extracted by mini-css-extract-plugin
export default {"cell":"TableCellSortable_cell__9TLvx","arrow":"TableCellSortable_arrow__wXMXp"};